<template>
  <div class="test-added-cover w-full h-full flex items-center justify-center">
    <p>ADDED</p>
  </div>
</template>

<style scoped>
.test-added-cover {
  position: absolute;
  border-radius: 4px;
  background: rgba(135, 135, 135, 0.70);
  color: #FFFFFF;
  /* font-family: "IBM Plex Sans Hebrew"; */
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
  z-index: 10
}
</style>